import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'
import { baseURL } from '../config'
let baseUrl = 'https://www.rakumart-2c.com:8080/api'
var baseURL1 = 'https://product.rakumart.com'
// 获取1688商品信息
export const getDetailsList1688 = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 获取自营商品
export const getDetailsList = data => Vue.prototype.getAxios(baseURL1 + "/api/product/detail?", data)
// 1688加入购物车
export const addCart1688 = data => Vue.prototype.getAxios(baseURL + "/index.php", data)
// 自营加入购物车
export const addCart = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=addCartSelf&token=" + token, data)
// 加入收藏
export const favoriteAdd = (token, data) => Vue.prototype.postAxios(baseURL + "/index.php?mod=inc&act=ordersys&str=favoriteAdd&token=" + token, data)

// 是否是违禁品
export const checkClient = (data) => axios({
    url: baseUrl + "/forbid/checkClient",
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
// 加购
// export const productAdd = (data) => Vue.prototype.postAxios('http://admin.rakumart.com/index.php?mod=inc&act=baseapi&str=productAdd', data)

export const productAdd = (data) => axios({
    url: 'http://admin.rakumart.com/index.php?mod=inc&act=baseapi&str=productAdd',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})

export const zhuanhuan = (data) => axios({
    url: 'http://www.rakumart-2c.com/index.php?mod=goods&act=taobao&id=22629282366911',
    method: "post",
    data: qs.stringify(data),
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    }
})
